module.exports = __webpack_public_path__ + "static/granner1thumb-a9fbc37112cad4dc1b3c38f9efa21cc1.jpg";